"use client";
import { useEffect, useState } from "react";
import Image from "next/image";
import { Modal} from "antd";
import { ChevronRight } from "lucide-react";
import { useRouter } from 'next/navigation'; 



export default function Discount() {
  const [isVisible, setIsVisible] = useState(false);
  let router = useRouter();

  useEffect(() => {
    // 检查本地存储中是否有记录用户关闭过弹窗
    const hasClosedDiscount = localStorage.getItem("hasClosedDiscount");

    if (!hasClosedDiscount) {
      // 如果没有关闭记录，显示弹窗
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // 在本地存储中记录用户已关闭弹窗
    localStorage.setItem("hasClosedDiscount", "true");
  };

  function toPath() {
    handleClose();
    router.push("/enterprise-upgrade");
  }
  return (
    <>
      <Modal
        open={isVisible}
        onCancel={handleClose}
        footer={null}
        centered
        width={1300}
        closable={true}
        className="discount-modal"
        maskClosable={false}
        styles={{ body: { padding: 0 } }}
      >
        <div className="h-[600px] bg-[#dce0e3] flex items-center justify-center p-4 font-sans relative overflow-hidden">

          {/* Metallic background texture */}
          <div
            className="absolute inset-0 opacity-30 mix-blend-overlay"
            style={{
              backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)`,
              backgroundSize: '10px 10px'
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/10 to-black/5"></div>

          <div className="relative z-10 w-full max-w-[1300px] flex flex-col lg:flex-row items-center justify-center gap-10">

            {/* Left Monitor */}
            <div className="hidden lg:flex flex-col items-center w-[360px] shrink-0 -ml-12 xl:-ml-32">
              <div className="relative w-[360px] h-[240px] bg-black rounded-t-2xl border-x-[8px] border-t-[8px] border-[#e0e0e0] p-1 shadow-2xl z-10">
                <img
                  src="/photo.avif"
                  alt="Website"
                  className="w-full h-full object-cover"
                  referrerPolicy="no-referrer"
                />
                {/* Bottom chin of monitor */}
                <div className="absolute -bottom-10 left-[-8px] right-[-8px] h-10 bg-[#e0e0e0] rounded-b-2xl flex items-center justify-center border-b-4 border-gray-400">
                  <span className="text-xs font-black text-gray-800 tracking-widest">MISUMI</span>
                </div>
              </div>
              {/* Stand */}
              {/* <div className="w-24 h-20 bg-gradient-to-b from-[#d0d0d0] to-[#a0a0a0] mt-10 z-0" style={{ clipPath: 'polygon(25% 0, 75% 0, 100% 100%, 0% 100%)' }}></div> */}
              {/* <div className="w-48 h-4 bg-[#a0a0a0] rounded-t-full shadow-lg"></div> */}
            </div>

            {/* Main Content */}
            <div className="flex flex-col items-center text-center space-y-12">

              <div className="space-y-6">
                <h1 className="text-5xl md:text-[56px] font-bold text-[#333333] tracking-wide">
                  请选择您的身份
                </h1>
                <div className="relative inline-block mt-4">
                  <p className="text-2xl md:text-[28px] text-[#444444] font-bold relative z-10 px-1">
                    根据身份提供个性化的推荐和服务介绍
                  </p>
                  {/* Yellow underline */}
                  <div className="absolute bottom-1.5 left-0 w-full h-3 bg-[#d4b86a] opacity-70 -z-10"></div>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex flex-col md:flex-row gap-6 justify-center w-full mt-8">
                <IdentityButton onClick={toPath} text="我是采购" />
                <IdentityButton onClick={toPath} text="我是设计师" />
                <IdentityButton onClick={toPath} text="我是设计师兼采购" />
              </div>

              {/* Link */}
              <div className="pt-6">
                <div  onClick={handleClose} className="cursor-pointer inline-flex items-center gap-2 text-[#0055a4] hover:text-[#003366] text-lg font-medium group transition-colors">
                  <PointingHandIcon className="w-6 h-6 rotate-90 text-[#0055a4] group-hover:text-[#003366] transition-colors" />
                  <span className="border-b border-[#0055a4] group-hover:border-[#003366] pb-0.5 transition-colors">
                    如何解决弹窗经常显示？
                  </span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Modal>


    </>
  );
}
function IdentityButton({ text, onClick }: { text: string, onClick: () => void }) {
  return (
    <button onClick={onClick} className="group flex items-center gap-4 bg-white px-6 py-4 rounded-full shadow-[0_4px_15px_rgba(0,0,0,0.08)] hover:shadow-[0_8px_25px_rgba(0,0,0,0.12)] transition-all duration-300 border border-gray-200 hover:-translate-y-1">
      <div className="bg-[#666666] group-hover:bg-[#444444] text-white rounded-full p-1 transition-colors">
        <ChevronRight className="w-6 h-6" strokeWidth={2.5} />
      </div>
      <span className="text-xl font-bold text-[#333333] whitespace-nowrap">{text}</span>
    </button>
  );
}

function PointingHandIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0" />
      <path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0" />
      <path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0" />
      <path d="M18 21H9c-1.6 0-3.2-.8-4.2-2.1L3 16.5a2.2 2.2 0 0 1 3.5-2.5L8 15.5V10" />
      <path d="M22 15v2a4 4 0 0 1-4 4h-0.5" />
    </svg>
  );
}
